const BaseError = require('make-error').BaseError;

class RemoveReferenceError extends BaseError {
    constructor(errorMessage='There are other records that still refer to this value. Please remove all references and try your operation again.') {
        super(errorMessage);
        this._isUserError = true;
    }
}

module.exports = RemoveReferenceError;
